import { MRT_SortingState } from 'material-react-table';
import qs from 'qs';
import {
  ConvocationSummary,
  MetaResumoAssembleia,
} from 'src/types/convocation-summary';
import { StrapiResponse } from 'src/types/http';

import { api } from '../../api/api';

type FetchTimelineDataFilters = {
  operation?: string | null;
  market: string;
  favorites: boolean;
  type: string;
  category: string;
  species: string;
  sort: MRT_SortingState;
  page: number;
  pageSize: number;
};

export const fetchTimelineData = async (filters: FetchTimelineDataFilters) => {
  const query = qs.stringify(filters, { encodeValuesOnly: true });
  const { data } = await api.get<StrapiResponse<ConvocationSummary[]>>(
    `/meta-resumos-assembleias/getAllCompleteWithSummary?${query}`,
  );
  return data;
};

export async function fetchTimelineOperationData(
  operationId: string,
  type: string,
  category: string,
  species: string,
  startDate: string,
  endDate: string,
) {
  const query = qs.stringify(
    {
      filters: {
        operationid: {
          $eq: operationId,
        },
        ...(type
          ? {
              tipodocumento: {
                $eq: type,
              },
            }
          : {}),
        ...(category
          ? {
              categoriadocumento: {
                $eq: category,
              },
            }
          : {}),
        ...(species
          ? {
              especiedocumento: {
                $eq: species,
              },
            }
          : {}),
        ...(startDate && endDate
          ? {
              datareferencia: {
                $gte: startDate,
                $lte: endDate,
              },
            }
          : {}),
      },
    },
    { encodeValuesOnly: true },
  );
  const { data } = await api.get<StrapiResponse<MetaResumoAssembleia[]>>(
    `/meta-resumos-assembleiass?${query}`,
  );
  return data;
}

export async function getTimelineFilters(operationId?: string) {
  const { data } = await api.get<{
    types: string[];
    categories: string[];
    species: string[];
    markets: string[];
  }>(
    `/meta-resumos-assembleias/buildFilters${operationId ? `?operationId=${operationId}` : ''}`,
  );
  return data;
}
